interface ErrorMessageProps {
    error?: string;
    className?: string;
}

export function ErrorMessage({ error, className }: Readonly<ErrorMessageProps>) {
    if (!error) return null;

    return <p className={`text-danger m-0 p-0 ${className}`}>{error}</p>;
}
